/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} License_Transfers_LeftInputs */



/**
* | output |
* | --- |
* | "{count} moves left this year" |
*
* @param {License_Transfers_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_transfers_left = /** @type {((inputs: License_Transfers_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Transfers_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} transfert(s) restant(s) cette année`)
	if (locale === "de") return /** @type {LocalizedString} */ (`noch ${i?.count} Übertragungen in diesem Jahr`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} trasferimenti rimasti quest'anno`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`осталось переносов в этом году: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} traslados restantes este año`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`今年还可转移 ${i?.count} 次`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`今年の残り移行回数: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इस साल ${i?.count} स्थानांतरण बाकी`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} transferências restantes este ano`)
	return /** @type {LocalizedString} */ (`${i?.count} moves left this year`)
});